module.exports = __webpack_public_path__ + "static/media/fleetvehiclesIcon.f5c9c924.svg";